import { galleryItems } from '@/mocks/home';

export default function GallerySection() {
  return (
    <section id="gallery" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b-2 border-foreground-950 pb-3">
          <div className="flex items-end gap-3">
            <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">高清图集</h3>
            <span className="mb-1 text-xs text-foreground-500">现场直击 · 比例还原</span>
          </div>
          <span className="flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900">
            <i className="ri-stack-line" />
            今日共 67 张现场图
          </span>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {galleryItems.map((item, i) => (
            <article
              key={item.id}
              className={`group relative cursor-pointer overflow-hidden rounded-lg border border-background-200 ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`w-full overflow-hidden ${i === 0 ? 'h-64 lg:h-[26rem]' : 'h-52'}`}>
                <img
                  src={item.image}
                  alt={item.caption}
                  title={`黑料大瓜 高清图集 ${item.caption}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-2 p-4">
                <div>
                  <div className="text-sm font-bold text-background-50">{item.caption}</div>
                  <div className="mt-0.5 text-xs text-background-300">点击查看完整大图</div>
                </div>
                <span className="shrink-0 rounded-md bg-background-50/95 px-2 py-1 text-xs font-medium text-foreground-900">
                  {item.count}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}